import React from 'react'
import { string, bool } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'

import './CheckBoxError.scss'
import I18nMessage from '../I18nMessage'

function CheckBoxError(props) {
  const { showError, errMsg } = props

  return showError && (
    <div className="passport-checkbox-error form-group-error">
      <i className="ic-cross-r" />
      <I18nMessage id={errMsg} />
    </div>
  )
}

CheckBoxError.propTypes = {
  showError: bool.isRequired,
  errMsg: string.isRequired,
}

export default withI18n(CheckBoxError)
